import React from 'react';

export default class HeaderLarge extends React.Component {
  
    render() {

        return (
   
            <header className="headerLarge">
                {/*{ content }*/}
                { this.props.children }
                 
            </header>
            
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Header/HeaderLarge.js